module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('LinkPath', {
    attrs: {
      "current-path": "consulta origem idn"
    }
  }), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding": "10px !important"
    }
  }, [_c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "margin": "16px",
      "display": "none"
    },
    attrs: {
      "id": "divAlert",
      "role": "alert"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "agent-input-group"
  }, [_c('div', {
    staticClass: "input-group mb-3"
  }, [_c('label', {
    staticClass: "input-group-text"
  }, [_vm._v("Digite o Identificador de Registro Biométrico ou o Cadastro de Pessoa Física")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idn),
      expression: "idn"
    }],
    staticClass: "form-control cpf",
    attrs: {
      "type": "text",
      "id": "idn"
    },
    domProps: {
      "value": (_vm.idn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.idn = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group pesquisa-box"
  }, [_c('div', {
    staticClass: "col-md-1 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-primary search-button",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "id": "btnSearchIDN",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.searchIDN()
      }
    }
  }, [_vm._v("\n                    Pesquisar\n                  ")])])])])])])])])]), _vm._v(" "), _c('section', [_c('BioInfo', {
    attrs: {
      "id": "bioInfo",
      "bio-info-list": _vm.bioInfoList
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5163bae2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/views/FindIDNOrigin.vue
// module id = 258
// module chunks = 0